import { apiRequest } from '@libs/apiRequest';
import { call, put } from 'redux-saga/effects';

export default function* (action) {
    const {
        meta: { handleComplete = () => {} },
        payload: { limit, offset, roleName, search },
    } = action;

    try {
        const params = {
            limit: limit ?? 10,
            offset: offset ?? '',
            'sort-descending': false,
        };
        if (roleName) params['role-name'] = roleName;
        if (search) params['search-term'] = search;

        const { data } = yield call(apiRequest, {
            url: 'user/get/all-with-roles',
            method: 'get',
            params,
        });

        return handleComplete(null, { data: data.data || [], total: parseInt(data.total) || 0 });
    } catch (error) {
        return handleComplete(error);
    }
}
